/*!
 * KoliBri - The accessible HTML-Standard
 */
var Callback;
(function (Callback) {
    Callback["onBlur"] = "onBlur";
    Callback["onChange"] = "onChange";
    Callback["onChangeHeaderCells"] = "onChangeHeaderCells";
    Callback["onChangePage"] = "onChangePage";
    Callback["onClick"] = "onClick";
    Callback["onClose"] = "onClose";
    Callback["onDblClick"] = "onDblClick";
    Callback["onFocus"] = "onFocus";
    Callback["onInput"] = "onInput";
    Callback["onKeyDown"] = "onKeyDown";
    Callback["onKeyPress"] = "onKeyPress";
    Callback["onKeyUp"] = "onKeyUp";
    Callback["onMouseDown"] = "onMouseDown";
    Callback["onMouseMove"] = "onMouseMove";
    Callback["onMouseOut"] = "onMouseOut";
    Callback["onMouseOver"] = "onMouseOver";
    Callback["onMouseUp"] = "onMouseUp";
    Callback["onReset"] = "onReset";
    Callback["onSelect"] = "onSelect";
    Callback["onSelectionChange"] = "onSelectionChange";
    Callback["onChangePageSize"] = "onChangePageSize";
    Callback["onSort"] = "onSort";
    Callback["onSubmit"] = "onSubmit";
    Callback["onToggle"] = "onToggle";
})(Callback || (Callback = {}));

var KeyboardKey;
(function (KeyboardKey) {
    KeyboardKey["ArrowDown"] = "ArrowDown";
    KeyboardKey["ArrowLeft"] = "ArrowLeft";
    KeyboardKey["ArrowRight"] = "ArrowRight";
    KeyboardKey["ArrowUp"] = "ArrowUp";
    KeyboardKey["Enter"] = "Enter";
    KeyboardKey["Space"] = " ";
})(KeyboardKey || (KeyboardKey = {}));

export { Callback as C, KeyboardKey as K };
//# sourceMappingURL=keyboard-DNd73LVa.js.map

//# sourceMappingURL=keyboard-DNd73LVa.js.map